import { useEffect } from "react";

/**
 * useGoogleOneTap
 * Shows Google One Tap sign-in popup automatically unless guest is already signed in.
 * @param onSignIn Callback with Google credential (JWT) when user signs in
 * @param clientId Google OAuth Client ID
 */
export function useGoogleOneTap(onSignIn: (credential: string) => void, clientId: string) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.localStorage.getItem("guest_google_signed_in")) return; // Already signed in
    if (!clientId) return;

    // Dynamically load Google One Tap script if not present
    if (!window.google || !window.google.accounts) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // @ts-ignore
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: (response: any) => {
            if (response.credential) {
              onSignIn(response.credential);
            }
          },
          auto_select: false,
          cancel_on_tap_outside: false,
        });
        // @ts-ignore
        window.google.accounts.id.prompt();
      };
      document.body.appendChild(script);
    } else {
      // @ts-ignore
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response: any) => {
          if (response.credential) {
            onSignIn(response.credential);
          }
        },
        auto_select: false,
        cancel_on_tap_outside: false,
      });
      // @ts-ignore
      window.google.accounts.id.prompt();
    }
  }, [onSignIn, clientId]);
} 